import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QRProductScanComponent } from '../qr-product-scan/qr-product-scan.component';
import { DataService } from '../services/data.service';
import { Utils } from '../services/utils';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.css']
})
export class LanguageSelectionComponent implements OnInit {

  languagesSubText = ["English", "Hindi", "Kannada", "Marathi", "Telugu", "Gujarati", "Odiya", "Punjabi", "Bangla", "Tamil"]
  languages = this.dataService.languages;

  defaultSelectedLanguage: any

  constructor(private dataService: DataService, private translateService: TranslateService,
    private qrProductScan: QRProductScanComponent, private utils: Utils) {
  }

  ngOnInit(): void {
    this.dataService.defaultSelectedLanguageObs.subscribe((value) => {
      this.defaultSelectedLanguage = value
    })
  }

  closeLanguageSelectionPopup() {
    localStorage.setItem('language_ISO', this.dataService.getLanguageISO())
    this.dataService.displayLangSelPopup.next(false);
    this.displayAppDownloadPopup();
  }

  onLanguageSelection(selectedLanguageISO: any) {
    if (this.dataService.getLanguageISO != selectedLanguageISO) {
      this.translateService.use(selectedLanguageISO);
      this.dataService.setLanguageISO(selectedLanguageISO);
      for (let lang of this.languages) {
        if (lang.iso6391 == selectedLanguageISO) {
          this.dataService.defaultSelectedLanguage.next(lang.name);
          this.defaultSelectedLanguage = lang.name;
          this.dataService.defaultSelectedLanguage.next(lang.name);
          break;
        }
      }
      localStorage.setItem('language_ISO', selectedLanguageISO)
      this.dataService.languageChange.next(true);
    }
    this.dataService.displayLangSelPopup.next(false);
    this.utils.showSpinner()
    this.displayAppDownloadPopup();
  }

  displayAppDownloadPopup(){
    if (!this.qrProductScan.isAppDownloadPopupDisplayed) {
      this.qrProductScan.displayAppDownloadPopup()
      this.qrProductScan.isAppDownloadPopupDisplayed = true
    }
  }
}
